import React from "react";
import styles from "./loading.module.scss";
import spinnerImg from "../../assets/img/spinner.svg";

interface LoadingProps {
    children?: any;
}

export const Loading: React.FC<LoadingProps> = ({ children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.container__loading}>
                <img src={spinnerImg} alt="" width={130} height={130} />

                <span className={styles.container__loading__text}>
                    Aguarde um instante
                </span>
            </div>
        </div>
    );
};
